import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export type LinkedProductPreviewCardProps = {
  productName: string;
  imageUrl: string;
  linkedProductTypeLabel: string;
  link: string;
};

export const LinkedProductPreviewCard: React.FC<
  LinkedProductPreviewCardProps
> = props => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Typography variant="h3" noWrap sx={{ width: '100%' }} align="center">
        {props.productName}
      </Typography>
      <img
        alt={props.productName}
        width="200px"
        style={{ aspectRatio: '1/1', objectFit: 'cover' }}
        src={props.imageUrl}
      />
      <Button component={Link} to={props.link} variant="outlined">
        View {props.linkedProductTypeLabel}
      </Button>
    </Box>
  );
};
